<template>
  <!-- Main content -->
  <section class="content">
    <div class="btn-box">
      <el-form :inline="true">
        <el-form-item label="用户user_id：">
          <el-input v-model="uid" placeholder="请输入用户user_id"></el-input>
        </el-form-item>
        <el-form-item label="订单号：">
          <el-input v-model="orderId" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="商品id：">
          <el-input v-model="goods_id" placeholder="请输入商品id"></el-input>
        </el-form-item>
        <el-form-item label="下单开始时间：">
          <el-date-picker
            v-model="order_pay_time_start"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="下单开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="下单结束时间：">
          <el-date-picker
            v-model="order_pay_time_end"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="下单结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="seach(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table v-if="!$store.state.isMobile" v-loading="loading" :data="jdList" border>
      <el-table-column fixed prop="order_id" label="编号" width="150">
      </el-table-column>
      <el-table-column fixed label="用户user_id(user_key)" width="200">
        <template slot-scope="scope">
          {{ scope.row.user_id }} ( {{ scope.row.user_key }} )
        </template>
      </el-table-column>
      <el-table-column
        prop="order_sn"
        label="订单号"
        width="150"
      ></el-table-column>
      <el-table-column
        label="商品标题"
        prop="item_title"
        width="300"
      ></el-table-column>
      <el-table-column
        prop="pay_amount"
        label="支付金额"
        width="100px"
      ></el-table-column>
      <el-table-column
        prop="user_commission"
        label="用户佣金"
        width="100px"
      ></el-table-column>
      <el-table-column label="下单订单">
        <template slot-scope="scope">
          {{ scope.row.order_time | dateTime }}
        </template>
      </el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">
          <span
            :class="
              scope.row.status == 1
                ? 'green'
                : scope.row.status == 3
                ? 'blue'
                : scope.row.status == 4
                ? 'warn'
                : scope.row.status == 5 ||
                  scope.row.status == 6 ||
                  scope.row.status == 7
                ? 'red'
                : ''
            "
          >
            {{ scope.row.status | status }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="alterDialog(scope.row)"
            v-if="scope.row.status == 1 || scope.row.status == 2"
            >修改</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="settlement(scope.row.order_id)"
            v-if="scope.row.status == 1"
            >结算</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div v-else>
      <el-card  v-for="(row, index) in jdList" :key="index">
        <div class="mini-cell">
          <div class="mini-label">编号</div>
          <div class="mini-value">{{ row.order_id }}</div>
        </div>
        <div class="mini-cell">
          <div class="mini-label">用户ID</div>
          <div class="mini-value">{{ row.user_id }}({{ row.user_key }})</div>
        </div>
        <div class="mini-cell">
          <div class="mini-label">订单号</div>
          <div class="mini-value">{{ row.order_sn }}</div>
        </div>
        <div class="mini-cell">
          <div class="mini-label">商品标题</div>
          <div class="mini-value">{{ row.item_title }}</div>
        </div>
        <div class="mini-cell">
          <div class="mini-label">支付金额</div>
          <div class="mini-value">{{ row.pay_amount }}</div>
        </div>
        <div class="mini-cell">
          <div class="mini-label">用户佣金</div>
          <div class="mini-value">{{ row.user_commission }}</div>
        </div>
        <div class="mini-cell">
          <div class="mini-label">下单订单</div>
          <div class="mini-value">{{ row.order_time | dateTime }}</div>
        </div>
        <div class="mini-cell">
          <div class="mini-label">订单状态</div>
          <div class="mini-value">
            <span
            :class="
              row.status == 1
                ? 'green'
                : row.status == 3
                ? 'blue'
                : row.status == 4
                ? 'warn'
                : row.status == 5 ||
                  row.status == 6 ||
                  row.status == 7
                ? 'red'
                : ''
            "
          >
            {{ row.status | status }}
          </span>
          </div>
        </div>
        <div class="mini-cell">
          <el-button
            type="primary"
            size="mini"
            @click="alterDialog(row)"
            v-if="row.status == 1 || row.status == 2"
            >修改</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="settlement(row.order_id)"
            v-if="row.status == 1"
            >结算</el-button
          >
        </div>
        </el-card>
    </div>
    <el-dialog
      title="修改"
      :visible.sync="dialog"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item label="用户user_id">
          <el-input v-model="unionid" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="佣金">
          <el-input v-model="user_commission" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="alter">确 定</el-button>
      </div>
    </el-dialog>
    <el-pagination
      background
      :layout="$store.state.isMobile ? 'pager' : 'total, sizes,prev, pager, next,jumper'"
      :total="total"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
    </el-pagination>
  </section>
  <!-- /.content -->
</template>

<script>
let common = JSON.parse(window.localStorage.getItem("common"));
import * as api from "@/config/api";
export default {
  name: "JdOrder",
  components: {},

  data() {
    return {
      jdList: [],
      total: 0,
      page: 1,
      pagesize: 10,
      goods_id: "",
      orderId: "",
      uid: "",
      order_pay_time_start: "",
      order_pay_time_end: "",
      loading: true,
      dialog: false,
      order_id: "",
      unionid: "",
      user_commission: "",
    };
  },
  watch: {},
  filters: {
    status(val) {
      let name = "";
      if (JSON.stringify(common.order_status_list).indexOf(val) != -1) {
        common.order_status_list.map((a, index) => {
          if (val === a.type) {
            name = a.name;
          }
        });
      }
      return name;
    },
    compare(val) {
      return val === 1 ? "是" : "否";
    },
    dateTime(val) {
      let day = new Date(Number(val) * 1000);
      if (Number(val) === 0) {
        return "";
      }
      return (
        day.getFullYear() +
        "-" +
        `${
          day.getMonth() + 1 < 10
            ? "0" + (day.getMonth() + 1)
            : day.getMonth() + 1
        }` +
        "-" +
        `${day.getDate() < 10 ? "0" + day.getDate() : day.getDate()}` +
        " " +
        `${day.getHours() < 10 ? "0" + day.getHours() : day.getHours()}` +
        ":" +
        `${day.getMinutes() < 10 ? "0" + day.getMinutes() : day.getMinutes()}` +
        ":" +
        `${day.getSeconds() < 10 ? "0" + day.getSeconds() : day.getSeconds()}`
      );
    },
  },
  mounted() {
    this.getJdOrderList();
  },
  methods: {
    settlement(id) {
      this.$confirm("请确定是否结算该订单", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.jdOrderSettlement(
            {
              order_id: id,
            },
            (res) => {
              this.$message({
                type: "success",
                message: "结算成功!",
              });
              this.getJdOrderList();
            }
          );
        })
        .catch(() => {});
    },
    alterDialog({ order_id, user_id, user_commission }) {
      this.order_id = order_id;
      this.unionid = user_id;
      this.user_commission = user_commission;
      this.dialog = true;
    },
    alter() {
      api.alterJDOrder(
        {
          order_id: this.order_id,
          user_id: this.unionid,
          user_commission: this.user_commission,
        },
        (res) => {
          console.log(res);
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialog = false;
          this.seach(1);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    close() {
      this.show = false;
      this.getJdOrderList();
    },
    getJdOrderList(page, size) {
      this.loading = true;
      api.getJdOrderList(
        {
          user_id: this.uid,
          goods_id: this.goods_id,
          order_sn: this.orderId,
          order_pay_time_start: this.order_pay_time_start,
          order_pay_time_end: this.order_pay_time_end,
          page: page ? page : this.page,
          pagesize: size ? size : this.pagesize,
        },
        (res) => {
          page && (this.page = page)
          this.jdList = res.data.list;
          this.total = Number(res.data.count);
          this.loading = false;
        }
      );
    },
    sizeChange(val) {
      this.pagesize = val;
      this.getJdOrderList();
    },
    currentChange(val) {
      this.page = val;
      this.getJdOrderList();
    },
    seach(page, size) {
      this.getJdOrderList(page, size);
    },
  },
};
</script>
<style scoped>
.cell {
  text-align: center;
}

.btn-box {
  text-align: left;
  margin-bottom: 20px;
}

img {
  width: 150px;
}

.red {
  color: #f56c6c;
}

.blue {
  color: #409eff;
}

.green {
  color: #67c23a;
}

.warn {
  color: #e6a23c;
}
</style>